import { fontTailwind } from "./fontList";

const getUIFontFamily = (getFontFamily: string): string => {
  const fontFamily = fontTailwind[getFontFamily as keyof typeof fontTailwind];
  return fontFamily;
};

export default getUIFontFamily;
